export function openBaiduMap(row) {
    console.log(row,'经纬度');
    let latitude1,longitude1,address
    let location = [...row.location]
    if(location.length>0){
        latitude1 = row.location[1]; // 目标位置的纬度
        longitude1 = row.location[0]; // 目标位置的经度
        address = encodeURIComponent(row.address);
    }else{
        latitude1 = 28.113154
        longitude1 = 112.986798
        address = '湖南省文化馆'
    }
    const url = `https://api.map.baidu.com/marker?location=${latitude1},${longitude1}&title=${address}&content=${address}&output=html`
    return window.open(url)
}